// ko strings for messages/checkout.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const checkout: Dict = {
  "checkout.declined":
    "카드가 거절되었어요. 카드사에 문의하거나 다른 결제 수단을 이용해 주세요.",
  "checkout.trialStarted": "무료 체험이 시작되었어요!",
  "checkout.thanks": "구매해 주셔서 감사해요!",
  "checkout.startTrial": "무료 체험 시작하기",
  "checkout.pay": "결제하기",
};

export default checkout;
